export const MAX_LENGTH_CURRENCY = 12;
export const LOCAL_CURRENCY = 'Rp';
export const LOCAL_PHONE_AREA = '+62';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/form.ts